import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import ContentPage from '@/repositories/data/content/ContentPage';
import HttpClient from '@/util/http/HttpClient';

export default class ContentPageRepository extends BaseCrudRepository<number, ContentPage, ContentPage> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/page/');
    }

    protected processBeforeCreate(user: ContentPage): ContentPage {
        if (user.pinned) {
            user.order = -1;
        } else {
            user.pinned = false;
        }

        return user;
    }

    protected processBeforeUpdate(user: ContentPage): ContentPage {
        if (user.pinned && user.order === null) {
            user.order = -1;
        }
        return user;
    }
}
